import React, { useEffect } from 'react';
import { Row, Col, Skeleton } from 'antd';
import { Input, Select } from 'formik-antd';
import { useIntl } from 'react-intl';
import EditorComponent from 'src/shared/components/editor';
import FormItem from 'src/shared/components/form-item';
import { Field } from 'formik';
import { useGetEmails } from 'src/pages/configuration/email-account/hooks/useGetEmails';
import { Email } from '../../infra/EmailInfra';
import { useGetLanguages } from '../../hooks/useGetLanguages';
import { Language } from '../../infra/LangInfra';
import languageData from 'src/domain/core/AppLanguageSwitcher/data';
import MainUtils from 'src/shared/utils/main';

function CampaignInfo() {
  const [emails, setEmails] = React.useState<Array<any>>([]);
  const [languages, setLanguages] = React.useState<Array<any>>([]);
  const { formatMessage } = useIntl();  // Using formatMessage for i18n
  const {
    mutate: getEmails,
    data: emailsData,
    isLoading: emailLoading,
  } = useGetEmails();
  const {
    mutate: getLanguages,
    data: languagesData,
    isLoading: LangLoading,
  } = useGetLanguages();

  useEffect(() => {
    getEmails();
    getLanguages();
  }, []);

  useEffect(() => {
    if (emailsData) setEmails(emailsData.Data.map((data) => Email(data)));
  }, [emailsData, emailLoading]);

  useEffect(() => {
    if (languagesData)
      setLanguages(languagesData.Data.map((data) => Language(data)));
  }, [languagesData, LangLoading]);

  return (
    <Row gutter={[0, 25]}>
      <Skeleton active loading={emailLoading}>
        <Col span={24}>
          <FormItem
            name='Name'
            label={formatMessage({ id: 'common.name' })}  // Using formatMessage here
            fieldCommponent={<Input name='Name' />}
          />
        </Col>
        <Col span={24}>
          <FormItem
            name='Subject'
            label={formatMessage({ id: 'mailing.subject' })}  // Using formatMessage here
            fieldCommponent={<Input name='Subject' />}
          />
        </Col>
        <Col span={24}>
          <FormItem
            name='Body'
            label={formatMessage({ id: 'mailing.body' })}  // Using formatMessage here
            fieldCommponent={
              <Field name='Body' type='input' as={EditorComponent} />
            }
          />
        </Col>
        <Col span={24}>
          <FormItem
            name='EmailAccountId'
            label={formatMessage({ id: 'mailing.emailAccount' })}  // Using formatMessage here
            fieldCommponent={
              <Select
                name='EmailAccountId'
                className='select-filter fullContent'
                allowClear
                showSearch
                placeholder={formatMessage({ id: 'mailing.emailAccount' })}  // Using formatMessage here
                filterOption={(input: any, option: any) =>
                  MainUtils.filterOptions(input, option, true)
                }>
                {emails?.map((item: any) => {
                  return (
                    <option
                      value={item.Value}
                      disabled={item.Disabled}
                      key={item.Value}
                      label={item?.Label}>
                      {item.Label}
                    </option>
                  );
                })}
              </Select>
            }
          />
        </Col>
        <Col span={24}>
          <FormItem
            name='LanguageId'
            label={formatMessage({ id: 'mailing.language' })}  // Using formatMessage here
            fieldCommponent={
              <Select
                name='LanguageId'
                className='select-filter fullContent'
                allowClear
                placeholder={formatMessage({ id: 'mailing.language' })}  // Using formatMessage here
              >
                {languages?.map((item: any) => {
                  return (
                    <Select.Option
                      value={item.Value}
                      disabled={item.Disabled}
                      key={item.Value}
                    >
                      {item.Label}
                    </Select.Option>
                  );
                })}
              </Select>
            }
          />
        </Col>
      </Skeleton>
    </Row>
  );
}

export default CampaignInfo;
